import type { ReactElement, ReactNode } from 'react';

/* The filter row above a table. Left-aligned controls, a spacer, then a count on the right.
 *
 * The count is a named slot rather than free children because "how many rows am I looking at" is the
 * question every list screen has to answer, and a screen that forgets it leaves the reader unable to
 * tell a filtered view from an empty estate.
 */

export interface ToolbarProps {
  readonly children: ReactNode;
  /* `| undefined` on every optional prop. `exactOptionalPropertyTypes` is on, so a caller
   * forwarding a conditional — `count={ready ? label : undefined}` — cannot pass explicit
   * undefined to a bare `prop?: T`, and every screen does exactly that. */
  readonly count?: string | undefined;
}

export function Toolbar({ children, count }: ToolbarProps): ReactElement {
  return (
    <div className="lq-toolbar">
      {children}
      <span className="lq-toolbar__spacer" />
      {count !== undefined && (
        /* `role="status"` so a screen reader hears the count change when a filter is applied. A
           silent count change is the moment a non-sighted user loses track of what they filtered. */
        <span className="lq-toolbar__count" role="status">
          {count}
        </span>
      )}
    </div>
  );
}
